import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { CustomQuestionEndPoint } from "../../api-routes";

const createCustomQuestion = async (data) => {
  return (
    await axiosInstance.post(
      CustomQuestionEndPoint.CREATE_CUSTOM_QUESTION,
      data
    )
  ).data;
};

const updateCustomQuestion = async ({ questionId, role, level, question }) => {
  return (
    await axiosInstance.patch(
      `${CustomQuestionEndPoint.UPDATE_CUSTOM_QUESTION}/${questionId}`,
      { role, level, question }
    )
  ).data;
};

const deleteCustomQuestion = async ({ questionId, role, level }) => {
  const params = new URLSearchParams({
    role,
    level,
  });
  return (
    await axiosInstance.delete(
      `${CustomQuestionEndPoint.DELETE_CUSTOM_QUESTION}/${questionId}?${params.toString()}`
    )
  ).data;
};

const getCustomQuestionsByRole = async ({ role, level, page = 1, limit = 5 }) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  
  if (level) {
    params.append("level", level);
  }

  const url = `${CustomQuestionEndPoint.GET_CUSTOM_QUESTIONS_BY_ROLE}/${encodeURIComponent(role)}?${params.toString()}`;
  
  return (await axiosInstance.get(url)).data;
};

export const useCreateCustomQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createCustomQuestion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customQuestions"] });
    },
  });
};

export const useUpdateCustomQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateCustomQuestion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customQuestions"] });
    },
  });
};

export const useDeleteCustomQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => deleteCustomQuestion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customQuestions"] });
    },
  });
};

export const useGetCustomQuestionsByRole = ({ role, level, page = 1, limit = 5 }) => {
  return useQuery({
    queryKey: ["customQuestions", role, level, page, limit],
    queryFn: () => getCustomQuestionsByRole({ role, level, page, limit }),
    enabled: !!role,
    keepPreviousData: true,
  });
};
